import { Component, Input, OnInit } from '@angular/core';
import {MdDialog, MdDialogRef} from '@angular/material';
import {SongDetailComponent} from '../../../songs/song-detail/song-detail.component';
import { SongsService} from '../../../api';
import {BlockUI, NgBlockUI} from 'ng-block-ui';

@Component({
  selector: 'song-info-details',
  templateUrl: './song-info-details.component.html',
  styleUrls: ['./song-info-details.component.css']
})
export class SongInfoDetailsComponent implements OnInit {
  @Input() currentSong: any;
  @Input() is_explicit: any;
  @Input() nextToCurrentSong: any;
  dialogRef2: MdDialogRef<SongDetailComponent>;
  private song:any;
  private song2:any;
  public creditsArray: any = [];
  public writersArray: any = [];
  @BlockUI() blockUI: NgBlockUI;

  constructor(public dialog: MdDialog,private songService: SongsService) { }

  ngAfterViewInit() {
  }
  
  ngOnInit() {
    this.song = "";
    this.song2 = "";
  }

  removeSlash(song){
    if(song) {
      if (typeof song.credits === "object" && song.credits != null) {
        for (var j = 0; j < song.credits.length; j++) {
          song.credits[j].credit_type = song.credits[j].credit_type.replace("_", " ");
          song.credits[j].credit_type = song.credits[j].credit_type.charAt(0).toUpperCase() + song.credits[j].credit_type.slice(1);
        }
      }
    }
    return song;
  }

  removeDuplicatCredits(song){
    if(song){
      this.writersArray.length = 0 ;
      for(var g = 0; g < 4; g++ ){
        song.writers.forEach((item, index) => {
          if (index !== song.writers.findIndex(i => i.writer === item.writer)) {
            this.writersArray.push(song.writers[index]);
            song.writers.splice(index, 1);
          }
        });
      }

      this.creditsArray.length = 0 ;
      for(var f = 0; f < 4; f++ ) {
        song.credits.forEach((item, index) => {
          if (index !== song.credits.findIndex(i => i.credit_type === item.credit_type)) {
            this.creditsArray.push(song.credits[index]);
            song.credits.splice(index, 1);
          }
        });
      }

      if(this.creditsArray && this.creditsArray.length){
        for(var j =0 ; j < this.creditsArray.length ; j++) {
          for(var k = 0; k < song.credits.length ; k++){
            if(song.credits[k].credit_type == this.creditsArray[j].credit_type){
              if(!(song.credits[k].name.includes(this.creditsArray[j].name))){

                if(!song.credits[k].values){
                  song.credits[k]["values"] = [];
                }
                if(!(song.credits[k].values.includes(song.credits[k].name))){
                  song.credits[k].values.push(song.credits[k].name);
                }
                if(!(song.credits[k].values.includes(this.creditsArray[j].name))){
                  song.credits[k].values.push(this.creditsArray[j].name);
                }
              }
            }
          }
        }
      }
      for(var k = 0; k < song.credits.length ; k++) {

        if(!song.credits[k].values){
          song.credits[k]["values"] = [];
        }
        if(!(song.credits[k].values.includes(song.credits[k].name))){
          var locationPartt = song.credits[k].name.split(",");

          for (var p = 0; p < locationPartt.length; p++) {
            locationPartt[p].replace(",", "");
            song.credits[k].values.push(locationPartt[p]);
          }
        }
        if(song.credits[k].location && song.credits[k].location != null){
          song.credits[k]["locations"] = [];

          var locationParts = song.credits[k].location.split(",");
          for(var m = 0; m < locationParts.length; m++ ){
            if(!(locationParts[m].includes("."))){
              song.credits[k].locations.push(locationParts[m]);
            }
            else{
              var locationParts2 = locationParts[m].split(".");
              for(var n = 0; n < locationParts2.length; n++ ){
                song.credits[k].locations.push(locationParts2[n]);
              }
            }
          }
        }
      }

      //publisher array making
      if(!song.publishers) {
        song["publisherss"] = [];
        if (song.publisher) {
          var locationParttt = song.publisher.split(",");

          for (var p = 0; p < locationParttt.length; p++) {
            locationParttt[p].replace(",", "");
            song.publisherss.push(locationParttt[p]);
          }
        }
      } else {
        song["publisherss"] = [];
        for (let m = 0; m < song.publishers.length; m++) {
          if (song.publishers[m].publisher) {
            song.publisherss.push(song.publishers[m].publisher);
          }
        }
      }
    }
    return song;
  }

  openSongDetail(event) {
    this.blockUI.start('Loading, please wait...');
    var width = '', height = '';
    var browserZoomLevel = Math.round(window.devicePixelRatio * 100);
    width = '37%';
    setTimeout(()=> {
      this.dialogRef2 = this.dialog.open(SongDetailComponent, {
        width: width
      });
      this.dialogRef2.componentInstance.slug = this.currentSong.slug;
      return false;
    },2000);

  }

  openSongDetail2(event) {
    this.blockUI.start('Loading, please wait...');
    var width = '', height = '';
    var browserZoomLevel = Math.round(window.devicePixelRatio * 100);
    width = '37%';
    setTimeout(()=> {
      this.dialogRef2 = this.dialog.open(SongDetailComponent, {
        width: width
      });
      this.dialogRef2.componentInstance.slug = this.nextToCurrentSong.slug;
      return false;
    },2000)
  }
}



// WEBPACK FOOTER //
// ./src/app/player/song-info/song-info-details/song-info-details.component.ts